export const BASE_URL = process.env.REACT_APP_BASE_URl
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL